import { Services } from '@sigma-frontend-libs/commons'

import filterByTag from '@/components/services/report-manager/commons/filterBy/tags/tag'

function renderItem(h, value) {
  return h(
    filterByTag,
    {
      props: { value }
    }
  )
}
function renderItems(h, items) {
  return items.map(item => {
    return renderItem.call(this, h, item)
  })
}
function renderRow(h, row) {
  if (row.length) {
    return h(
      'div',
      {
        class: `${Services['report-manager']}-filterBy__rows-row`
      },
      [ renderItems.call(this, h, row) ]
    )
  }
}
function renderRows(h) {
  return this.rows.map(row => {
    return renderRow.call(this, h, row)
  })
}

export default function(h) {
  if (this.hasItems) {
    return h(
      'div',
      {
        class: `${Services['report-manager']}-filterBy__rows`
      },
      [ renderRows.call(this, h) ]
    )
  }
}
